import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import './ClassDescriptionContainer.scss';

export default function ClassDescriptionContainer({ content }) {
  const fullyExpanded = 'auto';
  const shorter = 231;
  const [displayContent, setDisplayContent] = useState(shorter);
  const dropdownAnimationTime = 500; // ms


  return(
    <div className="ClassDescriptionContainer">
      <AnimateHeight
        duration={dropdownAnimationTime}
        height={displayContent}
        className={`content-container ${displayContent === fullyExpanded ? 'expanded' : ''}`}
        onMouseOver={(e) => { setDisplayContent(fullyExpanded); }}
        onMouseOut={(e) => { setDisplayContent(shorter); }}
      >
      {content}
      </AnimateHeight>
    </div>
  );
}
